import type { SupportedRepubName } from './types';

export type NavigationLink = {
  href: string;
  link: string;
  showWhenTipstersEnabled?: boolean;
};

export type NavigationConfig = {
  plusLinks: (urlPrefix: string) => NavigationLink[];
};

/**
 * Navigation configurations for each republic
 */
export const NAVIGATION_CONFIGS = {
  WS: {
    plusLinks: (urlPrefix: string) => [
      {
        href: `${urlPrefix}value-bets`,
        link: 'Value Bets',
      },
      {
        href: `${urlPrefix}trends`,
        link: 'Trends',
      },
    ],
  },
  US: {
    plusLinks: (urlPrefix: string) => [
      {
        href: `${urlPrefix}positive-ev`,
        link: 'Positive Value Bets',
      },
      {
        href: `${urlPrefix}betting-splits`,
        link: 'Public Betting Splits',
      },
      {
        href: `${urlPrefix}trends`,
        link: 'Trends',
      },
      {
        href: `${urlPrefix}match-center`,
        link: 'Match Center',
      },
      {
        href: `${urlPrefix}premium-picks`,
        link: 'Premium Picks',
        showWhenTipstersEnabled: false,
      },
    ],
  },
  GZ: {
    plusLinks: (urlPrefix: string) => [
      {
        href: `${urlPrefix}value-bets`,
        link: 'Scommesse di Valore',
      },
      {
        href: `${urlPrefix}trends`,
        link: 'Trend',
      },
      {
        href: `${urlPrefix}betting-splits`,
        link: 'Scelte degli scommettitori',
      },
      {
        href: `${urlPrefix}match-centre`,
        link: 'Match Center',
      },
      {
        href: `${urlPrefix}premium-tipsters`,
        link: 'Premium Tipster',
        showWhenTipstersEnabled: true,
      },
    ],
  },
  OC: {
    plusLinks: (urlPrefix: string) => [
      {
        href: `${urlPrefix}value-bets`,
        link: 'Value Bets',
      },
      {
        href: `${urlPrefix}betting-splits`,
        link: 'Public Betting Splits',
      },
      {
        href: `${urlPrefix}trends`,
        link: 'Trends',
      },
      {
        href: `${urlPrefix}premium-tipsters`,
        link: 'Premium Tipsters',
        showWhenTipstersEnabled: false,
      },
      {
        href: `${urlPrefix}horse-racing/premium-market-movers`,
        link: 'Premium Market Movers',
      },
      {
        href: `${urlPrefix}match-centre`,
        link: 'Match Centre',
      },
    ],
  },
} satisfies Record<SupportedRepubName, NavigationConfig>;
